import {validateRequired} from "./ValidationFunctions";

const RemedialTrainingFieldCofig = {
  fields: {
    title_label: {
      type: 'text',
      label: 'Remedial training title label',
      rules: [validateRequired('Title label')]
    },
    name_label: {
      type: 'text',
      label: 'Label name of remedial',
      rules: [validateRequired('Label name of remedial')]
    },
    hours_spend_label: {
      type: 'text',
      label: 'Hours spend label',
      rules: [validateRequired('Hours spend label')]
    },
    reason_label: {
      type: 'text',
      label: 'Reason label',
      rules: [validateRequired('Reason label')]
    },
    remedial_training_successful_label: {
      type: 'text',
      label: 'Remedial training successful label',
      rules: [validateRequired('Remedial training successful label')]
    },
    recap_of_results_label: {
      type: 'text',
      label: 'Recap of results label',
      rules: [validateRequired('Recap of results label')]
    },
    continue_remedial_training_label: {
      type: 'text',
      label: 'Continue remedial training label',
      rules: [validateRequired('Continue remedial training label')]
    }
  }
};

const CallTrackingFieldConfig = {
  fields: {
    title_label: {
      type: 'text',
      label: 'Remedial training title label',
      rules: [validateRequired('Title label')]
    },
    call_type_label: {
      type: 'text',
      label: 'Call type label',
      rules: [validateRequired('Call type label')]
    },
    time_label: {
      type: 'text',
      label: 'Time',
      rules: [validateRequired('Time')]
    },
    location_label: {
      type: 'text',
      label: 'Location label',
      rules: [validateRequired('Location label')]
    },
    was_there_arrest_label: {
      type: 'text',
      label: 'Was there arrest label',
      rules: [validateRequired('Was there arrest label')]
    },
    overview_label: {
      type: 'text',
      label: 'Overview label',
      rules: [validateRequired('Overview label')]
    },
    rating_label: {
      type: 'text',
      label: 'Rating label',
      rules: [validateRequired('Rating label')]
    },
  }
}


export {
  RemedialTrainingFieldCofig,
  CallTrackingFieldConfig
}
